import { useTheme } from "@mui/material";
import { memo } from "react";
import { ReactSVG } from "react-svg";
import DynamicIcon from "./DynamicIcon/DynamicIcon";

interface INavigationIconProps {
  icon?: string;
  iconColor?: string;
  defaultIcon: string;
  alt: string;
  size?: number;
}

export const NavigationIcon = memo(
  ({ icon, defaultIcon, iconColor, alt, size }: INavigationIconProps) => {
    const theme = useTheme();

    if (icon && icon.endsWith("Icon")) {
      return (
        <DynamicIcon
          icon={icon}
          style={{
            color: iconColor ?? theme.palette.primary.main,
            fontSize: 60,
          }}
        />
      );
    }

    if (icon && icon.endsWith(".svg")) {
      return (
        <ReactSVG
          beforeInjection={(svg) => {
            svg.style.height = "60px";
            svg.style.fill = iconColor ?? theme.palette.primary.main;
          }}
          src={icon}
        />
      );
    }

    return (
      <img
        style={{ height: size ?? 75 }}
        src={icon ? icon : defaultIcon}
        alt={alt}
      ></img>
    );
  }
);
